var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verified_black_24dp",
    transform: "translate(-0.393 -0.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 78,
    height: 78,
    transform: "translate(0.393 0.393)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(3.283 4.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M73.22,35.936l-8.01-9.159,1.116-12.113L54.475,11.972,48.271,1.5,37.11,6.293,25.949,1.5l-6.2,10.472L7.894,14.631,9.01,26.777,1,35.936l8.01,9.159L7.894,57.24l11.851,2.692,6.2,10.5L37.11,65.611,48.271,70.4l6.2-10.472,11.851-2.692L65.21,45.127ZM60.253,40.794l-1.838,2.134.263,2.79.591,6.4-6.237,1.412-2.757.624-1.444,2.429L45.579,62.1l-5.843-2.528L37.11,58.455l-2.593,1.116L28.673,62.1l-3.25-5.482-1.444-2.429-2.757-.624-6.237-1.412.591-6.434.263-2.79L14,40.794,9.765,35.969,14,31.11l1.838-2.134-.3-2.823-.591-6.368,6.237-1.412,2.757-.624,1.444-2.429,3.25-5.515,5.843,2.528,2.626,1.116L39.7,12.333l5.843-2.528L48.8,15.32l1.444,2.429L53,18.373l6.237,1.412-.591,6.4-.263,2.79L60.22,31.11l4.235,4.826Z",
    transform: "translate(-1 -1.5)",
    fill: "#2f68fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M18.764,27.172l-7.616-7.649L6.29,24.415,18.764,36.922l24.1-24.161L38,7.87Z",
    transform: "translate(11.076 13.041)",
    fill: "#2f68fa"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCompleted);
export default __webpack_public_path__ + "static/media/task_completed.4fc471383011d357c704a1df5675b216.svg";
export { ForwardRef as ReactComponent };